import axios from "axios";

const API_BASE = process.env.REACT_APP_USER_SERVICE_URL + "/admins/sellers";

/**
 * Fetch sellers with HATEOAS pagination
 * @param {Object} options
 * @param {number} options.page
 * @param {number} options.size
 * @param {string} options.search
 * @param {string} options.role
 */
export async function fetchSellers({ page = 0, size = 10, search, role } = {}) {
  const params = { page, size };
  if (search) params.search = search;
  if (role) params.role = role;

  try {
    const res = await axios.get(API_BASE, { params });
    const data = res.data;

    const embedded = data._embedded ?? {};
    const sellers = embedded.adminSellerResponseList ?? [];

    return {
      sellers: sellers.map((seller) => ({
        id: seller.id,
        fullName: seller.fullName,
        email: seller.email,
        phone: seller.phone,
        status: seller.status,
        roles: seller.roles,
        addresses: seller.addresses,
        companyName: seller.companyName,
        businessLicensePath: seller.businessLicensePath,
        licenseUploadedAt: seller.licenseUploadedAt,
        licenseVerified: seller.licenseVerified,
        licenseVerifiedAt: seller.licenseVerifiedAt,
        createdAt: seller.createdAt,
        updatedAt: seller.updatedAt,
      })),
      page: data.page,
      links: data._links,
    };
  } catch (err) {
    console.error("Failed to fetch sellers:", err);
    return {
      sellers: [],
      page: { number: 0, totalPages: 0 },
      links: {},
    };
  }
}

// Update seller status
export async function updateSellerStatus(sellerId, status) {
  return axios.put(`${API_BASE}/${sellerId}/status`, { status });
}
// Verify seller license
export async function approveSeller(sellerId) {
  return axios.put(`${API_BASE}/approve/${sellerId}`);
}

// Delete seller
export async function deleteSeller(sellerId) {
  return axios.delete(`${API_BASE}/${sellerId}`);
}
